import { ApolloClient, ApolloLink, concat, HttpLink, InMemoryCache } from '@apollo/client'
import { SupportedChainId } from 'constants/chains'

import store from '../../state/index'

const DEFAULT_HARMONY_V3_SUBGRAPH_URL =
  process.env.NODE_ENV === 'production'
    ? '/subgraph/subgraphs/name/elephantswap/v3'
    : 'http://127.0.0.1:8100/subgraphs/name/elephantswap/v3'

export const HARMONY_V3_SUBGRAPH_URL = process.env.REACT_APP_V3_SUBGRAPH_URL ?? DEFAULT_HARMONY_V3_SUBGRAPH_URL

const DEFAULT_HARMONY_V2_SUBGRAPH_URL =
  process.env.NODE_ENV === 'production'
    ? '/subgraph/subgraphs/name/elephantproject/subgraph'
    : 'http://127.0.0.1:8100/subgraphs/name/elephantproject/subgraph'

export const HARMONY_V2_SUBGRAPH_URL = process.env.REACT_APP_V2_SUBGRAPH_URL ?? DEFAULT_HARMONY_V2_SUBGRAPH_URL

const CHAIN_SUBGRAPH_URL: Record<number, string> = {
  [SupportedChainId.MAINNET]: 'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v3',

  [SupportedChainId.ARBITRUM_ONE]: 'https://api.thegraph.com/subgraphs/name/ianlapham/arbitrum-minimal',

  [SupportedChainId.OPTIMISM]: 'https://api.thegraph.com/subgraphs/name/ianlapham/optimism-post-regenesis',

  [SupportedChainId.POLYGON]: 'https://api.thegraph.com/subgraphs/name/ianlapham/uniswap-v3-polygon',

  [SupportedChainId.CELO]: 'https://api.thegraph.com/subgraphs/name/jesse-sawa/uniswap-celo',

  [SupportedChainId.BNB]: 'https://api.thegraph.com/subgraphs/name/ianlapham/uniswap-v3-bsc',

  [SupportedChainId.HARMONY]: HARMONY_V3_SUBGRAPH_URL,
}

const httpLink = new HttpLink({ uri: HARMONY_V3_SUBGRAPH_URL })

// This middleware will allow us to dynamically update the uri for the requests based off chainId
// For more information: https://www.apollographql.com/docs/react/networking/advanced-http-networking/
const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const chainId = store.getState().application.chainId

  operation.setContext(() => ({
    uri: chainId && CHAIN_SUBGRAPH_URL[chainId] ? CHAIN_SUBGRAPH_URL[chainId] : HARMONY_V3_SUBGRAPH_URL,
  }))

  return forward(operation)
})

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, httpLink),
})

export const analyticsApolloClient = new ApolloClient({
  cache: new InMemoryCache({ dataIdFromObject: () => null }),
  link: concat(authMiddleware, httpLink),
})

export const v3AnalyticsApolloClient = new ApolloClient({
  cache: new InMemoryCache({ dataIdFromObject: () => false }),
  link: new HttpLink({ uri: HARMONY_V3_SUBGRAPH_URL }),
})

export const v2AnalyticsApolloClient = new ApolloClient({
  cache: new InMemoryCache({ dataIdFromObject: () => null }),
  link: new HttpLink({ uri: HARMONY_V2_SUBGRAPH_URL }),
})
